import React from "react";
import {observer, inject} from "mobx-react";
import Accordion from "@components/Accordion/Accordion";
import {Formik, Form, useField} from 'formik';
import * as Yup from 'yup';
import {TextInput, CheckboxInput, TextLabel} from "@components/Form/FormFields";

@inject("store")
@observer
export default class CustomerUsers extends React.Component {

    constructor(props) {
        super(props);
        this.loadAddresses = this.loadAddresses.bind(this);
        this.addNewAddress = this.addNewAddress.bind(this);
        this.deleteAddress = this.deleteAddress.bind(this);
        this.cancelAddNewAddress = this.cancelAddNewAddress.bind(this);
        this.state = {
            addresses: [],
            tempAddresses: []
        };
    }


    componentDidMount() {
        this.loadAddresses();
    }


    loadAddresses() {
        this.props.store.beriksson.customerAccountAddresses().then(res => {
            //console.log("berikssonStore.customerAccountAddresses() => ", res)
            this.setState({addresses: res})
        })
    }

    deleteAddress(customerAddressId) {
        this.props.store.beriksson.customerAccountAddressDelete(customerAddressId).then(res => {
            this.loadAddresses();
            this.props.store.order.fetchOrders();
            this.props.store.navigation.toast("Address raderades");

        })
    }

    cancelAddNewAddress() {
        this.setState({addresses: [...this.state.tempAddresses]});
    }

    addNewAddress() {
        this.setState({
            tempAddresses: [...this.state.addresses],
            addresses: [{
                CustomerAddressId: 0,
                CustomerFirstName: "",
                CustomerLastName: "",
                CustomerPhoneNumber: "",
                CustomerAddressName: "",
                CustomerCompanyName: "",
                CustomerAddress1: "",
                CustomerPostalCode: "",
                CustomerCity: "",
                CustomerCountry: "",
            }]
        })
    }


    render() {
        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer chosen</div>;
        }

        return (
            <div
            >
                <div className="row">
                    <div className="col-12">
                        <h4 className="text-normal pt-4">Adresser</h4>
                        <hr className="mb-3"/>
                        <div className={"customer-account-card"}>
                            <div className={"customer-account-header"}>
                                <div className={"d-flex hidden-sm-down"}>
                                    <div style={{flex: "0 0 25%"}}>
                                        Företag
                                    </div>
                                    <div style={{flex: "0 0 25%"}}>
                                        Adress
                                    </div>
                                    <div style={{flex: "0 0 25%"}}>
                                        Godsmottagare
                                    </div>
                                    <div style={{flex: "0 0 25%"}}>
                                        Adresstyp
                                    </div>
                                </div>
                            </div>
                            {this.state.addresses.map(address => {

                                const addressText = (address.CustomerAddress !== "") ? <span>{address.CustomerAddress1} <br/>{address.CustomerPostalCode} {address.CustomerCity}</span> : null;
                                const goodsReceiver = (address.CustomerAddress !== "") ? <span> {address.CustomerFirstName} {address.CustomerLastName} <br/> {address.CustomerPhoneNumber}</span> : null;

                                return (


                                    <div
                                        key={"address_" + address.CustomerAddressId}
                                        className={"customer-account-address"}
                                    >
                                        <Accordion
                                            key={"address"}
                                            className=''
                                            transitionDuration={250}
                                            selectedIndex={(address.CustomerAddressId === 0) ? 0 : -1}
                                            name="address"

                                        >
                                            <div
                                                data-header={<div className={"d-flex"}
                                                >

                                                    <div style={{flex: "0 0 25%"}} className={"hidden-sm-down"}>
                                                        {address.CustomerCompanyName}
                                                    </div>
                                                    <div style={{flex: "0 0 25%"}} className={"hidden-sm-down"}>
                                                        {addressText}
                                                    </div>
                                                    <div style={{flex: "0 0 25%"}} className={"hidden-sm-down"}>
                                                        {goodsReceiver}
                                                    </div>
                                                    <div style={{flex: "0 0 25%"}} className={"hidden-sm-down"}>
                                                        {address.CustomerAddressName === "Billing" ? "Faktura" : "Leverans"}
                                                    </div>
                                                    <div className={"hidden-md-up"}>
                                                        
                                                        <strong>{address.CustomerCompanyName}</strong><br/>
                                                        {addressText} <br />
                                                        {goodsReceiver}<br/>
                                                        Adresstyp: {address.CustomerAddressName === "Billing" ? "Faktura" : "Leverans"}
                                                    </div>
                                                </div>}
                                                data-headerclass="customer-account-address-accordion">
                                                <div className="customer-account-address-details">
                                                    <AddressForm
                                                        cancelAddNewAddress={this.cancelAddNewAddress}
                                                        loadAddresses={this.loadAddresses}
                                                        deleteAddress={this.deleteAddress}
                                                        address={address}
                                                        berikssonStore={this.props.store.beriksson}
                                                        navigation={this.props.store.navigation}
                                                        orderStore={this.props.store.order}
                                                    />

                                                </div>

                                            </div>
                                        </Accordion>


                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="col-12">
                        {!this.state.addresses.some(f => f.CustomerAddressId === 0) && <button className="btn btn-success"
                                                                                               type="submit"
                                                                                               onClick={this.addNewAddress}
                                                                                               disabled={this.state.addresses.some(f => f.CustomerAddressId === 0)}
                        >Lägg till ny adress
                        </button>}
                    </div>
                </div>

            </div>);

    }

    allZips = [{
        "Note": "",
        "Country": "Sweden",
        "ISO": "SE",
        "Format": "NNNNN (NNN NN)",
        "Regex": /^\d{3}\s*\d{2}$/i
    }];

}

const AddressForm = ({...props}) => {

    const postalCodeRegex = /^\d{3}\s*\d{2}$/i;
    const phoneNumberRegex = /^(\+46|0046)?[-\s\.]?[0-9]{2,4}[-\s\.]?[0-9]{5,10}/i;

    return (
        <Formik
            validateOnMount={true}
            initialValues={{
                customerAddressId: props.address.CustomerAddressId,
                cultureCode: props.cultureCode,
                nodeId: props.nodeId,
                addressType: props.address.CustomerAddressName === "Billing" ? "Faktura" : "Leverans",
                customerAddressName: props.address.CustomerAddressName,
                customerCompanyName: props.address.CustomerCompanyName,
                customerFirstName: props.address.CustomerFirstName,
                customerLastName: props.address.CustomerLastName,
                customerPhoneNumber: props.address.CustomerPhoneNumber,
                customerAddress1: props.address.CustomerAddress1,
                customerPostalCode: props.address.CustomerPostalCode,
                customerCity: props.address.CustomerCity,
                customerCountry: props.address.CustomerCountry,
            }}
            validationSchema={Yup.object({

                customerCompanyName: Yup.string()
                    .required('Måste anges'),


                customerFirstName: Yup.string()
                    .required('Måste anges'),

                customerLastName: Yup.string()
                    .required('Måste anges'),

                customerPhoneNumber: Yup.string()
                    .matches(phoneNumberRegex, "Felaktig formatering.")
                    .required('Måste anges'),
                    

                customerAddress1: Yup.string()
                    .required('Måste anges'),

                customerPostalCode: Yup.string()
                    .required('Måste anges')
                    .matches(postalCodeRegex, "Felaktig formatering. Godkänt format: NNNNN (NNN NN)"),

                customerCity: Yup.string()
                    .required('Måste anges')

            })}
            //onSubmit={onSubmitWithReCAPTCHA}
            onSubmit={(values, {setSubmitting}) => {
                props.berikssonStore.customerAccountAddressUpdate({...values, CustomerAddressId: props.address.CustomerAddressId}).then(
                    res => {

                        if (props.address.CustomerAddressId > 0) {
                            props.navigation.toast("Address uppdaterad");
                        } else {
                            props.navigation.toast("Address lades till");
                        }

                        props.loadAddresses();
                        props.orderStore.fetchOrders();


                        setSubmitting(false);
                    }
                )
                //alert(JSON.stringify(values, null, 2));


            }}

        >
            {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid, setErrors}) => {
                //  noValidate
                return <Form>
                    <div className={"row"}>
                        <div className={"col-sm-6"}>
                            <TextInput
                                autoFocus={values.CustomerAddressId === 0}
                                label="Företagsnamn"
                                name="customerCompanyName"
                                type="text"
                            /></div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-sm-3"}>
                            <TextInput
                                label="Förnamn"
                                name="customerFirstName"
                                type="text"
                            /></div>
                        <div className={"col-sm-3 "}>
                            <TextInput
                                label="Efternamn"
                                name="customerLastName"
                                type="text"
                            />
                        </div>

                        <div className={"col-sm-6 "}>
                            <TextInput
                                label="Telefonnummer"
                                name="customerPhoneNumber"
                                type="text"
                            /></div>


                        <div className={"col-sm-6 "}>
                            <TextInput
                                label="Adress"
                                name="customerAddress1"
                                type="text"
                            /></div>
                        <div className={"col-sm-6 "}>
                            <TextInput
                                label="Postnummer"
                                name="customerPostalCode"
                                type="text"
                            /></div>
                        <div className={"col-sm-6 "}>
                            <TextInput
                                label="Ort"
                                name="customerCity"
                                type="text"
                            />
                        </div>
                        <div className={"col-sm-6 "}>
                            <TextInput
                                label="Land"
                                name="customerCountry"
                                type="text"
                                disabled="disabled"
                            />
                        </div>
                        <div className={"col-sm-6 "}>
                            <TextLabel
                                label="Addresstyp"
                                name="addressType"
                                type="text"
                            />
                        </div>

                    </div>
                    <div className={"row"}>
                        <div className={"col-sm-6"}>

                        </div>
                        <div className={"col-sm-6 d-flex justify-content-end"}>
                            <button className="btn btn-success"
                                    type="submit"
                                    disabled={isSubmitting || !isValid}>Spara
                            </button>
                            {values.customerAddressId === 0 &&
                                <button className="ml-1 btn btn-light"
                                        type={"button"}
                                        onClick={() => props.cancelAddNewAddress()}
                                >Avbryt
                                </button>}
                            {(values.customerAddressId > 0 && props.address.CustomerAddressName !== "Billing") && <button type={"button"} className="ml-1 btn btn-light" onClick={() => {
                                if (confirm("Är du säker?")) {
                                    props.deleteAddress(values.customerAddressId);
                                }
                            }}>Ta bort</button>}

                        </div>
                    </div>


                </Form>
            }
            }
        </Formik>
    );
};


// @inject("store")
// @observer
// export default class DocTypeResellerApplication extends React.Component {
//     constructor(props) {
//         super(props);
//         //this.ref = Math.random().toString(36).substr(2, 9);
//     }
//
//     render() {
//         var content = this.props.model.content;
//         return (<SignupForm
//             recaptchaV2Key={this.props.store.navigation.recaptchaV2Key}
//             berikssonStore={this.props.store.beriksson}
//             nodeId={this.props.store.navigation.NodeId}
//             cultureCode={this.props.store.navigation.CultureCode}
//         />);
//     }
// }